module.exports = __webpack_public_path__ + "static/media/uae_dentist_logotypeLarge.8bc0b82c.png";